import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/(app)/channels/$id")({
  component: RouteComponent,
});

/**
 * Layout for a single channel. Children (`publish` = calendar, `analytics`,
 * `settings`) render through the outlet. The channel index redirects to
 * publish. Buffer-style per-channel navigation lives in the sidebar.
 */
function RouteComponent() {
  return <Outlet />;
}
